import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import React from 'react';

interface ConfirmStatusModalProps {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
    loading: boolean;
    selectedStatus: string;
    email_status: boolean;
    setEmail_status: (value: boolean) => void;
}

const ConfirmStatusModal = ({
    visible,
    onHide,
    onConfirm,
    loading,
    selectedStatus,
    email_status,
    setEmail_status
}: ConfirmStatusModalProps) => {
    return (
        <Dialog
            visible={visible}
            style={{ width: '550px' }}
            header="Confirm Tax Form Status"
            className="mx-3 lg:mx-0"
            draggable={false}
            modal
            footer={
                <>
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        className="p-button-secondary"
                        onClick={onHide}
                    />
                    <Button
                        label="Confirm"
                        icon="pi pi-check"
                        className="common-primary-button"
                        onClick={onConfirm}
                        loading={loading}
                    />
                </>
            }
            onHide={onHide}
        >
            <div className="">
                <div className="grid p-fluid formgrid">
                    <div className="field col-12 ">
                        <label style={{ fontSize: '16px' }}>
                            Confirm your status{' '}
                            <span style={{ fontWeight: '600' }} className="text-">
                                {selectedStatus}
                            </span>
                        </label>
                    </div>
                    {selectedStatus === 'Tax Filed' && (
                        <div className="field col-12 flex align-item-center">
                            <Checkbox
                                inputId="email_status"
                                checked={email_status}
                                onChange={(e: any) => setEmail_status(e.checked)}
                            />
                            <label htmlFor="email_status" className="ml-2 mb-0">
                                Email Status
                            </label>
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default ConfirmStatusModal;